const $ = require('jquery');
import _ from "underscore";
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import run from '../../utilities/run';
import {validateOnAllSelectChanges} from "../../utilities/select2able";
import render from "../../utilities/render";
import {setElementsFromScope} from "../../utilities/selectorHelpers";
import {createPreventDefault} from '../../utilities/general';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

const targetSelector = "#returns-rules-detail-id";
// Live form from jsp
run(targetSelector, ()=>{
  const el = $(targetSelector);
  returnsRulesDetail(el);
});


function returnsRulesDetail(el) {
  const activeRuleURL = el.data("activate-rule-url");
  const inActiveRuleURL = el.data("inactivate-rule-url");
  const activeRuleBtn = el.find(".activate-rule-btn");
  const inActiveRuleBtn = el.find(".deactivate-rule-btn");
  const detailURL =  el.data("detail-url");
	const editBtn =  el.find(".edit-rule-btn");

	const activateRuleModal = new SubmitModalFlow({
    confirmModalTitle: 'Activate Rule',
		confirmModalBody: `<div class="q-pad-all-xl">
							Once updated, these changes will be reflected throughout the application.
						  </div>`,
		confirmModalBtnText: 'Activate Rule',
		onConfirmClick: function(){
			activateRuleModal.showLoadingModal();
			activeReturnRule({url: activeRuleURL, success:activeRuleSuccess, error: activeRuleError});
		}
	});
	
	activateRuleModal.init();
  
	const deactiveRuleModal = new SubmitModalFlow({
		confirmModalTitle: 'Deactive Rule',
		confirmModalBody: `<div class="q-pad-all-xl">
							Once updated, these changes will be reflected throughout the application.
						  </div>`,
		confirmModalBtnText: 'Deactive Rule',
		onConfirmClick: function(){
			deactiveRuleModal.showLoadingModal();
			activeReturnRule({url: inActiveRuleURL, success:activeRuleSuccess, error: activeRuleError});
		}
	});
	
	deactiveRuleModal.init();
	
	$(activeRuleBtn).on("click", function(e){
		e.preventDefault();
		activateRuleModal.showConfirmModal();
	});
	 
	$(inActiveRuleBtn).on("click", function(e){
		e.preventDefault();
		deactiveRuleModal.showConfirmModal();
	});

	function activeReturnRule({url, success, error}){
		$.ajax({
			url: url,
			dataType:"TEXT",
			type: 'POST',
			success: success,
			error: error
		});
	}

	function activeRuleSuccess(returnRuleId){
		if(returnRuleId > 0){
			EditChecker.setPageClean();
			const detailUrlFullURL = `${detailURL}&returnRuleId=${returnRuleId}`;
			activateRuleModal.showSuccessModal();
			setTimeout(function() {
				location.href = detailUrlFullURL;
			}, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
		}else{
			activateRuleModal.showFailureModal();
		}
	}

	function activeRuleError(){
	  activateRuleModal.hideAllModals();
	}
	
	function inActiveRuleSuccess(returnRuleId){
		if(returnRuleId > 0){
			EditChecker.setPageClean();
			const detailUrlFullURL = `${detailURL}&returnRuleId=${returnRuleId}`;
			deactiveRuleModal.showSuccessModal();
			setTimeout(function() {
			 location.href = detailUrlFullURL;
			},SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
		}else{
			deactiveRuleModal.showFailureModal();
		}
	}

  function inActiveRuleError(){
	 deactiveRuleModal.hideAllModals();
  }

}




// WEBPACK FOOTER //
// ./src/pages/returnsRules/detail.js